const SUPPORTED_LANGUAGES = ["it", "en", "es"];
const DEFAULT_LANGUAGE = "it";

const TRANSLATIONS = {
  it: {
    aiAssistant: "Assistente AI",
    assistantAuto: "Assistente Auto",
    assistant: "Assistente",
    operator: "Operatore",
    waiting: "In attesa",
    operatorLower: "operatore",
    closeChat: "Chiudi chat",
    completeForm: "Completa il modulo per continuare...",
    writeMessage: "Scrivi un messaggio...",
    writeRequest: "Scrivi la tua richiesta...",
    writeYourMessage: "Scrivi il tuo messaggio",
    back: "Indietro",
    next: "Avanti",
    send: "Invia",
    close: "Chiudi",
    me: "Tu",
    cancelReply: "Annulla risposta",
    sendMessage: "Invia messaggio",
    openChat: "Apri chat",
    clickToStart: "Clicca per iniziare",
    chatWithUs: "Chatta con noi",
    chatWithUsShort: "Chatta",
    welcomeChatCta: "Hai una domanda? Siamo disponibili ora!",
    welcomeCtaAction: "Benvenuto",
    urlCtaPromozioniBody: "Scopri le promozioni e le offerte pensate per te.",
    urlCtaPromozioniAction: "Promozioni",
    urlCtaOfficinaBody: "Prenota un appuntamento in officina o richiedi assistenza.",
    urlCtaOfficinaAction: "Appuntamenti",
    urlCtaStockUsateBody: "Vuoi venire a vedere un'auto? Organizziamo una visita in showroom.",
    urlCtaStockNuoveBody: "Vuoi venire a vedere un'auto nuova? Ti aiutiamo a prenotare una visita.",
    urlCtaStockUsateAction: "Usate",
    urlCtaStockNuoveAction: "Nuove",
    fixedCtaOutgoingWelcome: "Ciao! Ho appena aperto il sito e vorrei parlare con qualcuno.",
    fixedCtaOutgoingUrlPromozioni: "Sono nella sezione promozioni e vorrei maggiori informazioni sulle offerte disponibili.",
    fixedCtaOutgoingUrlOfficina: "Vorrei prenotare un appuntamento in officina o ricevere assistenza sui servizi.",
    fixedCtaOutgoingUrlUsate: "Vorrei venire in concessionario per vedere un'auto usata. Potete aiutarmi a organizzare una visita?",
    fixedCtaOutgoingUrlNuove: "Vorrei venire in concessionario per vedere un'auto nuova. Potete aiutarmi a organizzare una visita?",
    scrollEngageBody: "Cerchi qualcosa in particolare? Possiamo aiutarti!",
    scrollEngageAction: "Scrivici",
    fixedCtaOutgoingScrollEngage: "Ciao, sto navigando il sito e vorrei ricevere assistenza.",
    orderable: "Ordinabile",
    unavailable: "Non disponibile",
    saveAmount: "Risparmi €{amount}",
    requestQuote: "Richiedi un preventivo",
    seeOptionsAndColors: "Vedi optional e colori",
    bookVisit: "Prenota una visita",
    technicalSheet: "Scheda tecnica",
    specialOffer: "Offerta speciale",
    from: "da ",
    ctaCarSearch: "Cerca un'auto",
    ctaPromotions: "Scopri le offerte",
    ctaService: "Servizi e assistenza",
    ctaRental: "Noleggio auto",
    ctaDefault: "Chatta con noi",
    openSearchPanel: "Apri pannello di ricerca",
    carSearchSubmit: "Cerca Auto",
    rentalSearchSubmit: "Cerca Noleggi",
    serviceSearchSubmit: "Richiedi Servizio",
    promotionsSearchSubmit: "Mostra Offerte",
    carSearchTitle: "Cerca la tua auto ideale",
    carSearchSubtitle: "Ti aiutiamo a trovare l'auto perfetta per te",
    budgetQuestion: "Qual e il tuo budget massimo?",
    example25000: "Es. 25000",
    fuelQuestion: "Che tipo di alimentazione preferisci?",
    gasoline: "Benzina",
    diesel: "Diesel",
    hybrid: "Ibrida",
    electric: "Elettrica",
    noPreference: "Non ho preferenze",
    additionalPreferencesQuestion: "Hai altre preferenze specifiche?",
    additionalPreferencesPlaceholder: "Es. colore, marca, anno di immatricolazione...",
    contactQuestion: "Vuoi essere ricontattato? (Opzionale)",
    phonePlaceholder: "Il tuo numero di telefono",
    contactHelpText: "Lascia il tuo numero se vuoi essere ricontattato da un nostro consulente",
    rentalTitle: "Noleggio Auto",
    rentalSubtitle: "Trova la soluzione di noleggio perfetta",
    privateOrBusinessQuestion: "Per uso privato o aziendale?",
    privateUse: "Privato",
    vatNumber: "Partita IVA",
    yearlyKmQuestion: "Quanti km percorri all'anno abitualmente?",
    upTo10kKm: "Fino a 10.000 km",
    between10k20kKm: "10.000 - 20.000 km",
    between20k30kKm: "20.000 - 30.000 km",
    over30kKm: "Oltre 30.000 km",
    monthlyBudgetQuestion: "Che budget mensile hai a disposizione? (Opzionale)",
    example300: "Es. 300",
    perMonth: "€/mese",
    serviceTitle: "Assistenza e Servizi",
    serviceSubtitle: "Prenota il servizio di cui hai bisogno",
    whichServiceQuestion: "Di che servizio hai bisogno?",
    serviceDetailsTitle: "Dettagli del servizio",
    vehicleInfoLabel: "Informazioni sul veicolo",
    vehicleInfoPlaceholder: "Es. Fiat 500, 2020, 1.2 benzina...",
    preferredDateLabel: "Data preferita (opzionale)",
    serviceMaintenance: "Tagliando",
    serviceInspection: "Revisione",
    serviceRepair: "Riparazione",
    serviceTires: "Cambio gomme",
    serviceRoadside: "Assistenza stradale",
    serviceOther: "Altro",
    promotionsTitle: "Promozioni e Offerte",
    promotionsSubtitle: "Scopri le migliori offerte disponibili",
    offerTypeQuestion: "Che tipo di offerta ti interessa?",
    promoNewCars: "Auto nuove",
    promoUsedCars: "Auto usate",
    promoFinancing: "Finanziamenti",
    promoTradeIn: "Permute",
    promoAccessories: "Accessori",
    promoAll: "Tutte",
    additionalDetailsTitle: "Dettagli aggiuntivi",
    budgetInterestLabel: "Budget di interesse (opzionale)",
    additionalDetailsLabel: "Dettagli aggiuntivi (opzionale)",
    additionalDetailsPlaceholder: "Es. marche preferite, tipo di auto...",
    forWhichCarAccessories: "Per quale auto ti servono gli accessori?",
    tradeInInfoTitle: "Informazioni sulla tua auto da permutare",
    carModelLabel: "Modello dell'auto",
    carModelPlaceholder: "Es. Fiat 500, Volkswagen Golf, BMW Serie 3...",
    registrationYearLabel: "Anno di immatricolazione",
    example2020: "Es. 2020",
    mileageLabel: "Chilometraggio",
    example50000: "Es. 50000",
    defaultHelpTitle: "Come possiamo aiutarti?",
    defaultHelpSubtitle: "Seleziona l'argomento di cui vorresti parlare",
    optionFindCar: "Cerca l'auto perfetta per te",
    optionBookWorkshop: "Prenota un appuntamento per l'officina",
    optionRequestInfo: "Richiedi informazioni",
    genericInfoMessage: "Ciao! Vorrei ricevere informazioni generali sui vostri servizi e veicoli. Potreste aiutarmi fornendomi dettagli su cosa offrite?",
    goodMorning: "Buongiorno!",
    goodAfternoon: "Buon pomeriggio!",
    goodEvening: "Buona sera!",
    welcomeConnectedMessage: "Benvenuto sulla chat di {dealerName}, un operatore si sta connettendo alla conversazione, scrivimi quello di cui hai bisogno in modo che possa aiutarti nel miglior modo possibile!",
    askOperator: "Chiedi ad un operatore",
    askMia: "Chiedi a",
    whatsappCta: "Chatta utilizzando WhatsApp",
    poweredBy: "Servito da ",
    pullToRefresh: "Trascina per aggiornare",
    releaseToRefresh: "Rilascia per aggiornare",
    refreshing: "Aggiornamento...",
    operatorTyping: "Operatore sta scrivendo",
    assistantTyping: "L'assistente sta scrivendo",
    operatorConnecting: "Un operatore si sta connettendo",
    whatsappVdpMessage: "Ciao sarei interessato a questo veicolo:\n\n{url}{miaId}",
    whatsappPageMessage: "Ciao vorrei piu informazioni,\nStavo leggendo questa pagina: {url}{miaId}",
    secondEngagementWhatsAppText: "Se preferisce, puo continuare la conversazione direttamente su WhatsApp dove potra ricevere risposte piu rapide dal nostro team.",
    secondEngagementPhoneText: "Abbiamo preso in carico la sua richiesta, il nostro operatore si connettera a momenti. Se preferisce essere ricontattato su WhatsApp o telefonicamente, ci lasci il suo numero di telefono.",
    inlineCarIntro: "Ciao! Sto cercando un'auto con queste caratteristiche:",
    inlineCarBudgetLabel: "Budget massimo",
    inlineFuelLabel: "Alimentazione",
    inlineOtherPrefsLabel: "Altre preferenze",
    inlineContactLabel: "Per essere ricontattato",
    inlineCarQuestion: "Potreste aiutarmi a trovare l'auto giusta?",
    inlineRentalIntro: "Buongiorno, sono interessato al noleggio auto:",
    inlineUsageLabel: "Tipo di utilizzo",
    inlineYearlyKmLabel: "Km annui abitualmente",
    inlineMonthlyBudgetLabel: "Budget mensile",
    inlineRentalQuestion: "Che soluzioni di noleggio avete disponibili?",
    inlineServiceIntro: "Salve, ho bisogno di assistenza per il mio veicolo:",
    inlineServiceTypeLabel: "Tipo di servizio",
    inlinePreferredDateLineLabel: "Data preferita",
    inlineServiceQuestion: "Potete aiutarmi?",
    inlinePromoAccessoriesIntro: "Ciao, sono interessato agli accessori:",
    inlineOfferTypeLabel: "Tipo di offerta",
    inlineAccessoriesQuestion: "Che accessori avete disponibili per questo modello?",
    inlinePromoTradeInIntro: "Ciao, sono interessato alla permuta della mia auto:",
    inlineYearLabel: "Anno",
    inlineMileageLineLabel: "Chilometraggio",
    inlineTradeInQuestion: "Quanto potreste valutare la mia auto per la permuta?",
    inlinePromoGeneralIntro: "Ciao, sono interessato alle vostre promozioni:",
    inlineBudgetInterestLineLabel: "Budget di interesse",
    inlineOtherDetailsLineLabel: "Altri dettagli",
    inlinePromoQuestion: "Quali sono le offerte disponibili?",
    carSearchToolIntro: "Ciao! Sto cercando un'auto tra quelle disponibili.",
    carSearchToolBudgetLine: "Ho un budget massimo di {budget}€.",
    carSearchToolAdditionalPrefsLine: "Inoltre, ho queste preferenze specifiche: {additionalInfo}",
    carSearchToolQuestion: "Avete a disposizione delle auto che potrebbero fare al caso mio? Spiegami perche le suggerisci.",
    fuelPrefGasoline: "Preferirei un'auto a benzina.",
    fuelPrefDiesel: "Sarei orientato su un'auto diesel.",
    fuelPrefHybrid: "Mi interessa la tecnologia ibrida.",
    fuelPrefElectric: "Vorrei passare alla mobilita elettrica.",
    fuelPrefNoPreference: "Non ho preferenze particolari sul tipo di alimentazione, sono aperto a tutte le opzioni.",
    searchResultsTitle: "Risultati Ricerca",
    searchResultsSubtitle: "Veicoli trovati per la tua ricerca",
    previousResult: "Risultato precedente",
    nextResult: "Risultato successivo",
    closeSearchPanel: "Chiudi pannello di ricerca",
    noResultsTitle: "Nessun risultato",
    noResultsDescription: "I risultati della ricerca veicoli appariranno qui quando disponibili",
    resultsCounterSingular: "risultato",
    resultsCounterPlural: "risultati",
    vehiclesCounterSingular: "veicolo",
    vehiclesCounterPlural: "veicoli",
    optionalShort: "optional",
    viewDocument: "Vedi documento",
    bookVisitMessage: "Vorrei prenotare una visita per: {title} (ID veicolo: {vehicleId})",
    requestQuoteStockMessage: "Sono interessato a questo veicolo, vorrei ricevere un preventivo: {title} (ID veicolo: {vehicleId})",
    requestQuoteConfigMessage: "Vorrei ricevere un preventivo per questo allestimento: {title} (Codice: {trimCode})",
    infoRequestMessage: "Vorrei piu informazioni su: {title}, veicolo {vehicleId}",
    promoFallbackLabel: "Promozione",
    vehicleDetails: "Dettagli del Veicolo",
    carUnavailableTitle: "Auto non piu disponibile",
    carUnavailableDescription: "Ci dispiace, ma questo veicolo non e piu disponibile nel nostro catalogo.",
    pageShort: "Pagina",
    promoShort: "Promo",
    generalInfoTab: "Informazioni Generali",
    accessoriesTab: "Accessori",
    yearLabel: "Anno",
    colorLabel: "Colore",
    kilometersLabel: "Chilometri",
    listPriceLabel: "Prezzo Listino",
    finalPriceLabel: "Prezzo Finale",
    modelLabel: "Modello",
    fuelLabel: "Carburante",
    toolCarStockSearch: "Cerco le auto perfette per te",
    toolVehicleDetails: "Recupero i dettagli del veicolo",
    toolValidate: "Verifico le informazioni",
    toolKnowledgeSearch: "Cerco le info che ti servono",
    toolBookingCheck: "Controllo la disponibilita",
    toolBookAppointment: "Prenoto il tuo appuntamento",
    toolConsultantIntervention: "Contatto un consulente",
    toolCustomerRegistration: "Preparo la registrazione",
    toolServiceLocations: "Trovo la sede piu vicina",
    toolProcessing: "Elaboro la richiesta...",
    connectionStatusConnected: "Connesso",
    connectionStatusReconnecting: "Riconnessione in corso...",
    connectionStatusConnecting: "Connessione in corso...",
    connectionStatusDisconnected: "Disconnesso",
    connectionStatusLost: "Connessione persa",
    connectionStatusAttempt: "Tentativo {current} di {total}",
    connectionStatusNextAttempt: "Prossimo tentativo in {seconds}s",
    connectionStatusRetry: "Riprova connessione",
  },
  en: {
    aiAssistant: "AI Assistant",
    assistantAuto: "Auto Assistant",
    assistant: "Assistant",
    operator: "Operator",
    waiting: "Waiting",
    operatorLower: "operator",
    closeChat: "Close chat",
    completeForm: "Complete the form to continue...",
    writeMessage: "Write a message...",
    writeRequest: "Write your request...",
    writeYourMessage: "Write your message",
    back: "Back",
    next: "Next",
    send: "Send",
    close: "Close",
    me: "You",
    cancelReply: "Cancel reply",
    sendMessage: "Send message",
    openChat: "Open chat",
    clickToStart: "Click to start",
    chatWithUs: "Chat with us",
    chatWithUsShort: "Chat",
    welcomeChatCta: "Have a question? We're available now!",
    welcomeCtaAction: "Welcome",
    urlCtaPromozioniBody: "Discover the promotions and offers we have for you.",
    urlCtaPromozioniAction: "Promotions",
    urlCtaOfficinaBody: "Book a workshop appointment or request assistance.",
    urlCtaOfficinaAction: "Workshop",
    urlCtaStockUsateBody: "Want to see a car in person? We can arrange a showroom visit.",
    urlCtaStockNuoveBody: "Want to see a new car in person? We will help you book a visit.",
    urlCtaStockUsateAction: "Used",
    urlCtaStockNuoveAction: "New",
    fixedCtaOutgoingWelcome: "Hi! I just landed on the website and would like to speak with someone.",
    fixedCtaOutgoingUrlPromozioni: "I'm on the promotions page and would like more information about the current offers.",
    fixedCtaOutgoingUrlOfficina: "I'd like to book a workshop appointment or get help with service.",
    fixedCtaOutgoingUrlUsate: "I'd like to visit the dealership to see a used car. Can you help me arrange a visit?",
    fixedCtaOutgoingUrlNuove: "I'd like to visit the dealership to see a new car. Can you help me arrange a visit?",
    scrollEngageBody: "Looking for something specific? We can help!",
    scrollEngageAction: "Write to us",
    fixedCtaOutgoingScrollEngage: "Hi, I'm browsing the site and would like some help.",
    orderable: "Orderable",
    unavailable: "Unavailable",
    saveAmount: "Save €{amount}",
    requestQuote: "Request a quote",
    seeOptionsAndColors: "See options and colors",
    bookVisit: "Book a visit",
    technicalSheet: "Technical sheet",
    specialOffer: "Special offer",
    from: "from ",
    ctaCarSearch: "Find a car",
    ctaPromotions: "See offers",
    ctaService: "Service and assistance",
    ctaRental: "Car rental",
    ctaDefault: "Chat with us",
    openSearchPanel: "Open search panel",
    carSearchSubmit: "Search Cars",
    rentalSearchSubmit: "Search Rentals",
    serviceSearchSubmit: "Request Service",
    promotionsSearchSubmit: "Show Offers",
    carSearchTitle: "Find your ideal car",
    carSearchSubtitle: "We help you find the perfect car for you",
    budgetQuestion: "What is your maximum budget?",
    example25000: "Ex. 25000",
    fuelQuestion: "What fuel type do you prefer?",
    gasoline: "Gasoline",
    diesel: "Diesel",
    hybrid: "Hybrid",
    electric: "Electric",
    noPreference: "No preference",
    additionalPreferencesQuestion: "Do you have other specific preferences?",
    additionalPreferencesPlaceholder: "Ex. color, brand, registration year...",
    contactQuestion: "Would you like to be contacted? (Optional)",
    phonePlaceholder: "Your phone number",
    contactHelpText: "Leave your number if you want to be contacted by one of our consultants",
    rentalTitle: "Car Rental",
    rentalSubtitle: "Find the perfect rental solution",
    privateOrBusinessQuestion: "Private or business use?",
    privateUse: "Private",
    vatNumber: "VAT Number",
    yearlyKmQuestion: "How many km do you usually drive per year?",
    upTo10kKm: "Up to 10,000 km",
    between10k20kKm: "10,000 - 20,000 km",
    between20k30kKm: "20,000 - 30,000 km",
    over30kKm: "Over 30,000 km",
    monthlyBudgetQuestion: "What monthly budget do you have? (Optional)",
    example300: "Ex. 300",
    perMonth: "€/month",
    serviceTitle: "Support and Services",
    serviceSubtitle: "Book the service you need",
    whichServiceQuestion: "Which service do you need?",
    serviceDetailsTitle: "Service details",
    vehicleInfoLabel: "Vehicle information",
    vehicleInfoPlaceholder: "Ex. Fiat 500, 2020, 1.2 gasoline...",
    preferredDateLabel: "Preferred date (optional)",
    serviceMaintenance: "Maintenance",
    serviceInspection: "Inspection",
    serviceRepair: "Repair",
    serviceTires: "Tire change",
    serviceRoadside: "Roadside assistance",
    serviceOther: "Other",
    promotionsTitle: "Promotions and Offers",
    promotionsSubtitle: "Discover the best available offers",
    offerTypeQuestion: "What type of offer are you interested in?",
    promoNewCars: "New cars",
    promoUsedCars: "Used cars",
    promoFinancing: "Financing",
    promoTradeIn: "Trade-in",
    promoAccessories: "Accessories",
    promoAll: "All",
    additionalDetailsTitle: "Additional details",
    budgetInterestLabel: "Budget of interest (optional)",
    additionalDetailsLabel: "Additional details (optional)",
    additionalDetailsPlaceholder: "Ex. preferred brands, car type...",
    forWhichCarAccessories: "For which car do you need accessories?",
    tradeInInfoTitle: "Information about your car for trade-in",
    carModelLabel: "Car model",
    carModelPlaceholder: "Ex. Fiat 500, Volkswagen Golf, BMW 3 Series...",
    registrationYearLabel: "Registration year",
    example2020: "Ex. 2020",
    mileageLabel: "Mileage",
    example50000: "Ex. 50000",
    defaultHelpTitle: "How can we help you?",
    defaultHelpSubtitle: "Select the topic you would like to discuss",
    optionFindCar: "Find the perfect car for you",
    optionBookWorkshop: "Book a workshop appointment",
    optionRequestInfo: "Request information",
    genericInfoMessage: "Hi! I would like general information about your services and vehicles. Could you help me with details on what you offer?",
    goodMorning: "Good morning!",
    goodAfternoon: "Good afternoon!",
    goodEvening: "Good evening!",
    welcomeConnectedMessage: "Welcome to the {dealerName} chat, an operator is connecting to the conversation. Tell me what you need so I can help you in the best way possible!",
    askOperator: "Ask an operator",
    askMia: "Ask",
    whatsappCta: "Chat using WhatsApp",
    poweredBy: "Powered by ",
    pullToRefresh: "Pull to refresh",
    releaseToRefresh: "Release to refresh",
    refreshing: "Refreshing...",
    operatorTyping: "Operator is typing",
    assistantTyping: "Assistant is typing",
    operatorConnecting: "An operator is connecting",
    whatsappVdpMessage: "Hi, I am interested in this vehicle:\n\n{url}{miaId}",
    whatsappPageMessage: "Hi, I would like more information,\nI was reading this page: {url}{miaId}",
    secondEngagementWhatsAppText: "If you prefer, you can continue the conversation directly on WhatsApp where you can receive faster responses from our team.",
    secondEngagementPhoneText: "We have received your request, our operator will connect shortly. If you prefer to be contacted on WhatsApp or by phone, please leave your phone number.",
    inlineCarIntro: "Hi! I am looking for a car with these features:",
    inlineCarBudgetLabel: "Maximum budget",
    inlineFuelLabel: "Fuel type",
    inlineOtherPrefsLabel: "Other preferences",
    inlineContactLabel: "To be contacted",
    inlineCarQuestion: "Could you help me find the right car?",
    inlineRentalIntro: "Good morning, I am interested in car rental:",
    inlineUsageLabel: "Usage type",
    inlineYearlyKmLabel: "Yearly km",
    inlineMonthlyBudgetLabel: "Monthly budget",
    inlineRentalQuestion: "What rental solutions do you have available?",
    inlineServiceIntro: "Hi, I need assistance for my vehicle:",
    inlineServiceTypeLabel: "Service type",
    inlinePreferredDateLineLabel: "Preferred date",
    inlineServiceQuestion: "Can you help me?",
    inlinePromoAccessoriesIntro: "Hi, I am interested in accessories:",
    inlineOfferTypeLabel: "Offer type",
    inlineAccessoriesQuestion: "Which accessories do you have for this model?",
    inlinePromoTradeInIntro: "Hi, I am interested in trading in my car:",
    inlineYearLabel: "Year",
    inlineMileageLineLabel: "Mileage",
    inlineTradeInQuestion: "How much could you value my car for trade-in?",
    inlinePromoGeneralIntro: "Hi, I am interested in your promotions:",
    inlineBudgetInterestLineLabel: "Budget of interest",
    inlineOtherDetailsLineLabel: "Other details",
    inlinePromoQuestion: "Which offers are available?",
    carSearchToolIntro: "Hi! I am looking for a car among your available stock.",
    carSearchToolBudgetLine: "My maximum budget is {budget}€.",
    carSearchToolAdditionalPrefsLine: "Also, I have these specific preferences: {additionalInfo}",
    carSearchToolQuestion: "Do you have cars that could fit my needs? Explain why you suggest them.",
    fuelPrefGasoline: "I would prefer a gasoline car.",
    fuelPrefDiesel: "I would be oriented toward a diesel car.",
    fuelPrefHybrid: "I am interested in hybrid technology.",
    fuelPrefElectric: "I would like to switch to electric mobility.",
    fuelPrefNoPreference: "I have no specific preference on fuel type, I am open to all options.",
    searchResultsTitle: "Search Results",
    searchResultsSubtitle: "Vehicles found for your search",
    previousResult: "Previous result",
    nextResult: "Next result",
    closeSearchPanel: "Close search panel",
    noResultsTitle: "No results",
    noResultsDescription: "Vehicle search results will appear here when available",
    resultsCounterSingular: "result",
    resultsCounterPlural: "results",
    vehiclesCounterSingular: "vehicle",
    vehiclesCounterPlural: "vehicles",
    optionalShort: "options",
    viewDocument: "View document",
    bookVisitMessage: "I would like to book a visit for: {title} (Vehicle ID: {vehicleId})",
    requestQuoteStockMessage: "I am interested in this vehicle and would like a quote: {title} (Vehicle ID: {vehicleId})",
    requestQuoteConfigMessage: "I would like to receive a quote for this trim: {title} (Code: {trimCode})",
    infoRequestMessage: "I would like more information about: {title}, vehicle {vehicleId}",
    promoFallbackLabel: "Promotion",
    vehicleDetails: "Vehicle Details",
    carUnavailableTitle: "Car no longer available",
    carUnavailableDescription: "Sorry, this vehicle is no longer available in our catalog.",
    pageShort: "Page",
    promoShort: "Promo",
    generalInfoTab: "General Information",
    accessoriesTab: "Accessories",
    yearLabel: "Year",
    colorLabel: "Color",
    kilometersLabel: "Kilometers",
    listPriceLabel: "List Price",
    finalPriceLabel: "Final Price",
    modelLabel: "Model",
    fuelLabel: "Fuel",
    toolCarStockSearch: "I am finding the best cars for you",
    toolVehicleDetails: "I am retrieving vehicle details",
    toolValidate: "I am validating the information",
    toolKnowledgeSearch: "I am searching the information you need",
    toolBookingCheck: "I am checking availability",
    toolBookAppointment: "I am booking your appointment",
    toolConsultantIntervention: "I am contacting a consultant",
    toolCustomerRegistration: "I am preparing registration",
    toolServiceLocations: "I am finding the nearest location",
    toolProcessing: "Processing your request...",
    connectionStatusConnected: "Connected",
    connectionStatusReconnecting: "Reconnecting...",
    connectionStatusConnecting: "Connecting...",
    connectionStatusDisconnected: "Disconnected",
    connectionStatusLost: "Connection lost",
    connectionStatusAttempt: "Attempt {current} of {total}",
    connectionStatusNextAttempt: "Next attempt in {seconds}s",
    connectionStatusRetry: "Retry connection",
  },
  es: {
    aiAssistant: "Asistente IA",
    assistantAuto: "Asistente de autos",
    assistant: "Asistente",
    operator: "Operador",
    waiting: "En espera",
    operatorLower: "operador",
    closeChat: "Cerrar chat",
    completeForm: "Completa el formulario para continuar...",
    writeMessage: "Escribe un mensaje...",
    writeRequest: "Escribe tu solicitud...",
    writeYourMessage: "Escribe tu mensaje",
    back: "Atrás",
    next: "Siguiente",
    send: "Enviar",
    close: "Cerrar",
    me: "Tú",
    cancelReply: "Cancelar respuesta",
    sendMessage: "Enviar mensaje",
    openChat: "Abrir chat",
    clickToStart: "Haz clic para empezar",
    chatWithUs: "Chatea con nosotros",
    chatWithUsShort: "Chat",
    welcomeChatCta: "¿Tienes una pregunta? ¡Estamos disponibles ahora!",
    welcomeCtaAction: "Bienvenido",
    urlCtaPromozioniBody: "Descubre las promociones y ofertas pensadas para ti.",
    urlCtaPromozioniAction: "Promociones",
    urlCtaOfficinaBody: "Reserva cita en taller o solicita asistencia.",
    urlCtaOfficinaAction: "Citas",
    urlCtaStockUsateBody: "¿Quieres ver un coche en persona? Organizamos una visita al showroom.",
    urlCtaStockNuoveBody: "¿Quieres ver un coche nuevo? Te ayudamos a reservar una visita.",
    urlCtaStockUsateAction: "Ocasión",
    urlCtaStockNuoveAction: "Nuevos",
    fixedCtaOutgoingWelcome: "Hola! Acabo de entrar en la web y me gustaria hablar con alguien.",
    fixedCtaOutgoingUrlPromozioni: "Estoy en la seccion de promociones y me gustaria mas informacion sobre las ofertas.",
    fixedCtaOutgoingUrlOfficina: "Me gustaria reservar cita en taller o recibir asistencia sobre los servicios.",
    fixedCtaOutgoingUrlUsate: "Me gustaria ir al concesionario para ver un coche de ocasion. Pueden ayudarme a organizar una visita?",
    fixedCtaOutgoingUrlNuove: "Me gustaria ir al concesionario para ver un coche nuevo. Pueden ayudarme a organizar una visita?",
    scrollEngageBody: "Buscas algo en particular? Podemos ayudarte!",
    scrollEngageAction: "Escríbenos",
    fixedCtaOutgoingScrollEngage: "Hola, estoy navegando el sitio y me gustaria recibir ayuda.",
    orderable: "Por encargo",
    unavailable: "No disponible",
    saveAmount: "Ahorra €{amount}",
    requestQuote: "Solicitar presupuesto",
    seeOptionsAndColors: "Ver opciones y colores",
    bookVisit: "Reservar visita",
    technicalSheet: "Ficha técnica",
    specialOffer: "Oferta especial",
    from: "desde ",
    ctaCarSearch: "Buscar un auto",
    ctaPromotions: "Descubrir ofertas",
    ctaService: "Servicios y asistencia",
    ctaRental: "Alquiler de autos",
    ctaDefault: "Chatea con nosotros",
    openSearchPanel: "Abrir panel de busqueda",
    carSearchSubmit: "Buscar Autos",
    rentalSearchSubmit: "Buscar Alquileres",
    serviceSearchSubmit: "Solicitar Servicio",
    promotionsSearchSubmit: "Mostrar Ofertas",
    carSearchTitle: "Busca tu auto ideal",
    carSearchSubtitle: "Te ayudamos a encontrar el auto perfecto para ti",
    budgetQuestion: "Cual es tu presupuesto maximo?",
    example25000: "Ej. 25000",
    fuelQuestion: "Que tipo de combustible prefieres?",
    gasoline: "Gasolina",
    diesel: "Diesel",
    hybrid: "Hibrido",
    electric: "Electrico",
    noPreference: "Sin preferencias",
    additionalPreferencesQuestion: "Tienes otras preferencias especificas?",
    additionalPreferencesPlaceholder: "Ej. color, marca, ano de matriculacion...",
    contactQuestion: "Quieres que te contactemos? (Opcional)",
    phonePlaceholder: "Tu numero de telefono",
    contactHelpText: "Deja tu numero si quieres que te contacte uno de nuestros asesores",
    rentalTitle: "Alquiler de Autos",
    rentalSubtitle: "Encuentra la solucion de alquiler perfecta",
    privateOrBusinessQuestion: "Uso privado o empresarial?",
    privateUse: "Privado",
    vatNumber: "NIF IVA",
    yearlyKmQuestion: "Cuantos km recorres normalmente al ano?",
    upTo10kKm: "Hasta 10.000 km",
    between10k20kKm: "10.000 - 20.000 km",
    between20k30kKm: "20.000 - 30.000 km",
    over30kKm: "Mas de 30.000 km",
    monthlyBudgetQuestion: "Que presupuesto mensual tienes? (Opcional)",
    example300: "Ej. 300",
    perMonth: "€/mes",
    serviceTitle: "Asistencia y Servicios",
    serviceSubtitle: "Reserva el servicio que necesitas",
    whichServiceQuestion: "Que servicio necesitas?",
    serviceDetailsTitle: "Detalles del servicio",
    vehicleInfoLabel: "Informacion del vehiculo",
    vehicleInfoPlaceholder: "Ej. Fiat 500, 2020, 1.2 gasolina...",
    preferredDateLabel: "Fecha preferida (opcional)",
    serviceMaintenance: "Mantenimiento",
    serviceInspection: "Revision",
    serviceRepair: "Reparacion",
    serviceTires: "Cambio de neumaticos",
    serviceRoadside: "Asistencia en carretera",
    serviceOther: "Otro",
    promotionsTitle: "Promociones y Ofertas",
    promotionsSubtitle: "Descubre las mejores ofertas disponibles",
    offerTypeQuestion: "Que tipo de oferta te interesa?",
    promoNewCars: "Autos nuevos",
    promoUsedCars: "Autos usados",
    promoFinancing: "Financiacion",
    promoTradeIn: "Permutas",
    promoAccessories: "Accesorios",
    promoAll: "Todas",
    additionalDetailsTitle: "Detalles adicionales",
    budgetInterestLabel: "Presupuesto de interes (opcional)",
    additionalDetailsLabel: "Detalles adicionales (opcional)",
    additionalDetailsPlaceholder: "Ej. marcas preferidas, tipo de auto...",
    forWhichCarAccessories: "Para que auto necesitas los accesorios?",
    tradeInInfoTitle: "Informacion de tu auto para permuta",
    carModelLabel: "Modelo del auto",
    carModelPlaceholder: "Ej. Fiat 500, Volkswagen Golf, BMW Serie 3...",
    registrationYearLabel: "Ano de matriculacion",
    example2020: "Ej. 2020",
    mileageLabel: "Kilometraje",
    example50000: "Ej. 50000",
    defaultHelpTitle: "Como podemos ayudarte?",
    defaultHelpSubtitle: "Selecciona el tema del que quieres hablar",
    optionFindCar: "Busca el auto perfecto para ti",
    optionBookWorkshop: "Reservar cita para taller",
    optionRequestInfo: "Solicitar informacion",
    genericInfoMessage: "Hola, me gustaria recibir informacion general sobre sus servicios y vehiculos. Podrian ayudarme con mas detalles?",
    goodMorning: "Buenos dias!",
    goodAfternoon: "Buenas tardes!",
    goodEvening: "Buenas noches!",
    welcomeConnectedMessage: "Bienvenido al chat de {dealerName}, un operador se esta conectando a la conversacion. Escribeme lo que necesitas para poder ayudarte de la mejor manera posible.",
    askOperator: "Habla con un operador",
    askMia: "Preguntar a",
    whatsappCta: "Chatea por WhatsApp",
    poweredBy: "Desarrollado por ",
    pullToRefresh: "Desliza para actualizar",
    releaseToRefresh: "Suelta para actualizar",
    refreshing: "Actualizando...",
    operatorTyping: "El operador esta escribiendo",
    assistantTyping: "El asistente está escribiendo",
    operatorConnecting: "Un operador se esta conectando",
    whatsappVdpMessage: "Hola, me interesa este vehiculo:\n\n{url}{miaId}",
    whatsappPageMessage: "Hola, me gustaria mas informacion,\nEstaba leyendo esta pagina: {url}{miaId}",
    secondEngagementWhatsAppText: "Si lo prefiere, puede continuar la conversacion directamente por WhatsApp donde podra recibir respuestas mas rapidas de nuestro equipo.",
    secondEngagementPhoneText: "Hemos recibido su solicitud, nuestro operador se conectara en breve. Si prefiere que lo contactemos por WhatsApp o por telefono, dejenos su numero.",
    inlineCarIntro: "Hola, estoy buscando un auto con estas caracteristicas:",
    inlineCarBudgetLabel: "Presupuesto maximo",
    inlineFuelLabel: "Combustible",
    inlineOtherPrefsLabel: "Otras preferencias",
    inlineContactLabel: "Para ser contactado",
    inlineCarQuestion: "Podrian ayudarme a encontrar el auto adecuado?",
    inlineRentalIntro: "Buenos dias, estoy interesado en alquiler de autos:",
    inlineUsageLabel: "Tipo de uso",
    inlineYearlyKmLabel: "Km anuales",
    inlineMonthlyBudgetLabel: "Presupuesto mensual",
    inlineRentalQuestion: "Que soluciones de alquiler tienen disponibles?",
    inlineServiceIntro: "Hola, necesito asistencia para mi vehiculo:",
    inlineServiceTypeLabel: "Tipo de servicio",
    inlinePreferredDateLineLabel: "Fecha preferida",
    inlineServiceQuestion: "Pueden ayudarme?",
    inlinePromoAccessoriesIntro: "Hola, estoy interesado en accesorios:",
    inlineOfferTypeLabel: "Tipo de oferta",
    inlineAccessoriesQuestion: "Que accesorios tienen disponibles para este modelo?",
    inlinePromoTradeInIntro: "Hola, estoy interesado en la permuta de mi auto:",
    inlineYearLabel: "Ano",
    inlineMileageLineLabel: "Kilometraje",
    inlineTradeInQuestion: "Cuanto podrian valorar mi auto para la permuta?",
    inlinePromoGeneralIntro: "Hola, estoy interesado en sus promociones:",
    inlineBudgetInterestLineLabel: "Presupuesto de interes",
    inlineOtherDetailsLineLabel: "Otros detalles",
    inlinePromoQuestion: "Que ofertas hay disponibles?",
    carSearchToolIntro: "Hola, estoy buscando un auto entre los disponibles.",
    carSearchToolBudgetLine: "Tengo un presupuesto maximo de {budget}€.",
    carSearchToolAdditionalPrefsLine: "Ademas, tengo estas preferencias especificas: {additionalInfo}",
    carSearchToolQuestion: "Tienen autos que puedan encajar conmigo? Expliquen por que los sugieren.",
    fuelPrefGasoline: "Preferiria un auto de gasolina.",
    fuelPrefDiesel: "Me orientaria por un auto diesel.",
    fuelPrefHybrid: "Me interesa la tecnologia hibrida.",
    fuelPrefElectric: "Quiero pasar a la movilidad electrica.",
    fuelPrefNoPreference: "No tengo preferencias particulares sobre combustible, estoy abierto a todas las opciones.",
    searchResultsTitle: "Resultados de busqueda",
    searchResultsSubtitle: "Vehiculos encontrados para tu busqueda",
    previousResult: "Resultado anterior",
    nextResult: "Resultado siguiente",
    closeSearchPanel: "Cerrar panel de busqueda",
    noResultsTitle: "Sin resultados",
    noResultsDescription: "Los resultados de busqueda de vehiculos apareceran aqui cuando esten disponibles",
    resultsCounterSingular: "resultado",
    resultsCounterPlural: "resultados",
    vehiclesCounterSingular: "vehiculo",
    vehiclesCounterPlural: "vehiculos",
    optionalShort: "opcionales",
    viewDocument: "Ver documento",
    bookVisitMessage: "Quisiera reservar una visita para: {title} (ID vehiculo: {vehicleId})",
    requestQuoteStockMessage: "Estoy interesado en este vehiculo, quisiera recibir un presupuesto: {title} (ID vehiculo: {vehicleId})",
    requestQuoteConfigMessage: "Quisiera recibir un presupuesto para este acabado: {title} (Codigo: {trimCode})",
    infoRequestMessage: "Quisiera mas informacion sobre: {title}, vehiculo {vehicleId}",
    promoFallbackLabel: "Promocion",
    vehicleDetails: "Detalles del Vehiculo",
    carUnavailableTitle: "Auto no disponible",
    carUnavailableDescription: "Lo sentimos, este vehiculo ya no esta disponible en nuestro catalogo.",
    pageShort: "Pagina",
    promoShort: "Promo",
    generalInfoTab: "Informacion General",
    accessoriesTab: "Accesorios",
    yearLabel: "Ano",
    colorLabel: "Color",
    kilometersLabel: "Kilometros",
    listPriceLabel: "Precio de Lista",
    finalPriceLabel: "Precio Final",
    modelLabel: "Modelo",
    fuelLabel: "Combustible",
    toolCarStockSearch: "Busco los autos perfectos para ti",
    toolVehicleDetails: "Recupero los detalles del vehiculo",
    toolValidate: "Verifico la informacion",
    toolKnowledgeSearch: "Busco la informacion que necesitas",
    toolBookingCheck: "Verifico la disponibilidad",
    toolBookAppointment: "Reservo tu cita",
    toolConsultantIntervention: "Contacto a un asesor",
    toolCustomerRegistration: "Preparo el registro",
    toolServiceLocations: "Encuentro la sede mas cercana",
    toolProcessing: "Procesando tu solicitud...",
    connectionStatusConnected: "Conectado",
    connectionStatusReconnecting: "Reconectando...",
    connectionStatusConnecting: "Conectando...",
    connectionStatusDisconnected: "Desconectado",
    connectionStatusLost: "Conexión perdida",
    connectionStatusAttempt: "Intento {current} de {total}",
    connectionStatusNextAttempt: "Siguiente intento en {seconds}s",
    connectionStatusRetry: "Reintentar conexion",
  },
};

export const normalizeLanguage = (value) => {
  if (!value || typeof value !== "string") {
    return DEFAULT_LANGUAGE;
  }

  const normalized = value.toLowerCase().split("-")[0];
  return SUPPORTED_LANGUAGES.includes(normalized)
    ? normalized
    : DEFAULT_LANGUAGE;
};

export const getBrowserLanguage = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  const languages = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language];

  for (const language of languages) {
    const normalized = normalizeLanguage(language);
    if (SUPPORTED_LANGUAGES.includes(normalized)) {
      return normalized;
    }
  }

  return DEFAULT_LANGUAGE;
};

const interpolate = (text, variables = {}) =>
  text.replace(/\{(\w+)\}/g, (_, key) => String(variables[key] ?? ""));

export const translate = (key, language = DEFAULT_LANGUAGE, variables = {}) => {
  const normalized = normalizeLanguage(language);
  const localized = TRANSLATIONS[normalized]?.[key];
  const fallback = TRANSLATIONS[DEFAULT_LANGUAGE]?.[key];
  const value = localized || fallback || key;
  return interpolate(value, variables);
};

export const createTranslator = (language = DEFAULT_LANGUAGE) => {
  const normalized = normalizeLanguage(language);
  return (key, variables) => translate(key, normalized, variables);
};
